export enum EOpenPoseTransformControlsSpace {
  LOCAL = 'local',
  WORLD = 'world',
}
